module.exports = __webpack_public_path__ + "static/media/bbb-event.4c1aedfb.jpg";